import React from "react";
import "./labelText.scss";

const LabelText = ({ section, text }) => {
  return (
    <div
      className={`label-main-container ${
        section === "documents"
          ? "document-section-text"
          : section === "messages"
            ? "messages-section-text"
            : section === "schemeDocuments"
              ? "schemeDocuments-section-text"
              : section === "pot-details"
                ? "pot-details-section-text"
                : ""
      }`}
    >
      <span>{text}</span>
    </div>
  );
};

export default LabelText;
